exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-2ae40d10]{vertical-align:middle;border-style:none;width:100px}", ""]);

// exports
